<template>
    <div class="formi539-tab-content">
        <div class="formi539-header">
            <p class="header-content">
                FORM I-539
            </p>
        </div>
        <template >
            <div style="height: 200px;display:table;width:100%;">
                <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Folder_icon.svg`" style="margin-bottom:20px;" /> 
                    <p>Once the employer initiates the Form I-539,</p>
                    <p> Information  will be reflected here.</p>
                </div>
            </div> 
        </template>
    </div>
  
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
        
    }
</script>

<style lang="scss" scoped>
    .formi539-tab-content {
            position: relative;
			padding: 0 15px;
			display: inline-block;
			width: 100%;
			min-height: 350px;
    }
   .header-content
   {
    font-weight: 600;
    color: #333;
    font-size: 15px;
    padding-top: 2px;
   }
   .formi539-body
   {
    margin-top: 60px;
    text-align: center;
   }
   .formi539-header
   {
    padding: 0 0 20px 0;
    border-bottom: 1px dashed #ccc;
    margin: 10px 0;
   }
   .buttonsblock
   {
    text-align: center;
    padding-top: 23px;
   }
    .text-style{
        font-size: 13px;
        text-align: justify;
        line-height: 20px;
    }
   
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI539/FormI539Intro.vue